import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=de847e70&scoped=true&"
import script from "./feedBack.vue?vue&type=script&lang=js&"
export * from "./feedBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de847e70",
  null
  
)

export default component.exports